import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-icon',
  templateUrl: '../../../../assets/icons/main-sprite.svg',
 
})
export class spriteSvg {
}
